import { PAINS } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Problem = () => (
  <section className="bg-white" data-testid="problem-section">
    <Container className="grid gap-12 py-20 lg:grid-cols-12 lg:py-32">
      <div className="lg:col-span-3">
        <Overline>O problema</Overline>
      </div>
      <div className="lg:col-span-9">
        <MaskText className="font-display text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl lg:text-[64px]"
          lines={["Marketing não pode funcionar", <>isolado do <span className="text-[#1238CE]">Comercial.</span></>, <span className="text-slate-400">Vendas não podem depender</span>, <span className="text-slate-400">apenas de esforço individual.</span>]} />
        <div className="mt-14 grid gap-10 md:grid-cols-2">
          <Reveal>
            <p className="text-base leading-relaxed text-slate-600 md:text-lg">
              Quando as áreas não conversam, o investimento vira ruído: campanhas que não geram oportunidades, times comerciais sem processo e metas que dependem de sorte.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <blockquote className="border-l-2 border-[#CCFF00] pl-6">
              <p className="font-display text-xl font-medium leading-snug text-[#0F172A] md:text-2xl">
                “Meu compromisso é conectar as decisões de hoje aos resultados que sua empresa precisa alcançar amanhã.”
              </p>
              <footer className="font-mono-x mt-4 text-xs uppercase tracking-[0.2em] text-slate-600">— Maicon Roberto</footer>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </Container>
    <div className="grain relative overflow-hidden bg-[#1238CE] py-16 text-white lg:py-24" data-testid="pains-strip">
      <Container>
        <Reveal className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <h3 className="font-display text-3xl font-bold leading-[1.05] tracking-[-0.03em] sm:text-5xl">
            Sinais de que sua empresa <br className="hidden sm:block" />precisa de <span className="text-[#CCFF00]">direção.</span>
          </h3>
          <span className="font-mono-x text-xs uppercase tracking-[0.22em] text-white/80">05 sintomas comuns</span>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {PAINS.map((p, i) => (
            <Reveal key={p} delay={i * 0.08} className="h-full">
              <div className="group relative flex h-full min-h-[170px] sm:min-h-[220px] flex-col justify-between overflow-hidden rounded-[24px] border border-white/20 bg-white/[0.06] p-6 backdrop-blur transition-[transform,border-color] duration-500 hover:-translate-y-2 hover:border-[#CCFF00] lg:min-h-[300px]"
                data-testid={`pain-card-${i}`}>
                <span className="absolute inset-0 translate-y-full bg-[#CCFF00] transition-transform duration-500 ease-out group-hover:translate-y-0" />
                <span className="font-display relative text-6xl font-extrabold leading-none tracking-[-0.05em] text-[#CCFF00] transition-colors duration-500 group-hover:text-[#060B19] lg:text-7xl">0{i + 1}</span>
                <span className="font-display relative text-xl font-semibold leading-tight tracking-[-0.01em] transition-colors duration-500 group-hover:text-[#060B19] lg:text-2xl">{p}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </div>
  </section>
);
